<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">VENTES</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="sForm.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="sForm.trashed" class="mt-1 w-full form-select">
          <option :value="null"/>
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <div class="flex">
        <button class="btn-indigo py-2.5 mr-4 flex items-center disabled:opacity-50" @click="showForm()">
          <div v-if="sending" class="btn-spinner mr-2" />
          <span>Nouvelle vente</span>
        </button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-2 pt-6 pb-4 items-center text-center">Client</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Type</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Reference</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Quantity</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Prix</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Marge</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Telephone</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Paiement</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Facture</th>
        </tr>
        <tr v-for="sale in sales.data" :key="sale.id" class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer" >
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center">
              {{ sale.client }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.type }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.reference }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.quantity }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.price }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.margin }}
            </span>
          </td>
          <td class="border-t" >
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.phone }}
            </span>
          </td>
          <td class="border-t" >
            <span class="px-4 py-4 flex items-center text-center" tabindex="-1">
              {{ sale.payment }}
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer la facture" @click="printInvoice(sale)">
              <svg class="h-10 w-10 mx-auto text-indigo-600 hover:text-indigo-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
        </tr>
        <tr v-if="sales.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No sales found.</td>
        </tr>
      </table>
      <!-- Vente Modal -->
      <jet-dialog-modal max-width="4xl" :show="detailForm" :closeable="false" @close="detailForm = false">
        <template #title>
          Nouvelle vente
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">

              <text-input v-model="form.client" class="pr-6 pb-8 w-full lg:w-1/3" label="Client" :optional="true"/>
              <div v-if="errors.client" class="form-error">{{ errors.client }}</div>

              <div class="pr-6 pb-8 w-full lg:w-1/3">
                <label class="form-label">Agent: <i class="text-gray-400 text-sm">optionnelle</i></label>
                <multiselect v-model="form.agent" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                             :options="agents" :searchable="true" :clear-on-select="false" open-direction="bottom">
                </multiselect>
              </div>
              <div class="pr-6 pb-8 w-full lg:w-1/3">
                <label class="form-label">Type d'article:</label>
                <multiselect v-model="form.type" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                             :options="types" :searchable="true" :clear-on-select="false" @input="asyncFind" open-direction="bottom">
                </multiselect>
              </div>

              <div class="pr-6 pb-8 w-full lg:w-1/3">
                <label class="form-label">Article:</label>
                <multiselect v-model="form.item" deselect-label="supprimer" track-by="reference" label="reference" placeholder="Select one"
                             :options="itemsData" :searchable="true" open-direction="bottom" @input="update" :clear-on-select="false" :loading="isLoading">
                </multiselect>
              </div>

              <textarea-input v-model="form.description" :optional="true" class="pr-6 pb-8 w-full lg:w-1/3" label="Désignation"/>

              <div class="pr-6 pb-8 w-full lg:w-1/3">
                <label class="form-label">Quantité:</label>
                <jet-input type="number" :min="1" :max="maxQty" :oninput="`validity.valid||(value='')`" v-model="form.quantity" placeholder="1" :error="errors.quantity"/>
              </div>

              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label text-gray-800">Prix:</label>
                <p class="font-bold p-2 border border-gray-400 rounded h-10">{{form.price}} Dh</p>
                <div v-if="errors.price" class="form-error">{{ errors.price }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <span class="cursor-pointer" title="Envoyer au test" @click="addRow()">
                  <svg class="h-10 w-10 mx-auto text-green-500 hover:text-green-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                </span>
              </div>
              <div class="pr-6 pb-8 w-full lg:w-1/3">
                <label class="form-label">Marge:</label>
                <jet-input type="number" :min="0" :oninput="`validity.valid||(value='')`"  v-model="form.margin" placeholder="0" :error="errors.margin"/>
              </div>

              <text-input v-model="form.billing_phone" :optional="true" class="pr-6 pb-8 w-full lg:w-1/3" label="Telephone"/>

              <textarea-input v-model="form.billing_address" :optional="true" class="pr-6 pb-8 w-full lg:w-1/3" label="Addresse"/>

              <text-input v-model="form.ice" class="pr-6 pb-8 w-full lg:w-1/3" :optional="true" label="ICE"/>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="detailForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 mr-10" :class="{ 'opacity-25': processing }" :disabled="processing" @click.native="submit()">
            Sauvegarder
          </jet-button>
        </template>
      </jet-dialog-modal>
    </div>
    <pagination :links="sales.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import JetDialogModal from '@/Jetstream/DialogModal'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import TextInput from "@/Shared/TextInput"
import JetButton from '@/Jetstream/Button'
import TextareaInput from "@/Shared/TextareaInput"
import JetDangerButton from '@/Jetstream/DangerButton'
import JetInput from '@/Jetstream/Input'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  metaInfo: {title: 'Liste Ventes'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDialogModal,
    JetSecondaryButton,
    TextInput,
    JetButton,
    TextareaInput,
    JetDangerButton,
    JetInput,
    Multiselect
  },
  props: {
    sales: Object,
    agents: Array,
    types: Array,
    filters: Object,
    errors: Object,
  },
  data() {
    return {
      detailForm: false,
      sending: false,
      isLoading: false,
      processing: false,
      maxQty: 999,
      itemsData: [],
      sForm: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      form: {
        client: null,
        agent: null,
        type: null,
        item: null,
        description: null,
        price: null,
        margin: 0,
        quantity: 1,
        billing_address: null,
        billing_phone: null,
        ice: null,
      },
    }
  },
  watch: {
    sForm: {
      handler: throttle(function () {
        let query = pickBy(this.sForm)
        this.$inertia.replace(this.route('sales.list', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
    'form.quantity': function () {
      this.updatePrice()
    },
  },
  methods: {
    addRow() {

    },
    reset() {
      this.sForm = mapValues(this.sForm, () => null)
    },
    showForm() {
      this.detailForm = true
    },
    submit() {
      const data = new FormData()
      data.append('form', JSON.stringify(this.form) || '')
      this.$inertia.post(this.route('sales.submit'), data, {
        preserveScroll: true,
        onStart: () => this.processing = true,
        onFinish: () => this.processing = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.detailForm = false
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },
    printInvoice(sale) {
      var id = sale.id
      window.open(this.route('sales.invoice', id), "_blank");
    },
    asyncFind() {
      const params = {
        type: null,
      };
      this.isLoading = true
      params.type = this.form.type.name

      return axios.get(this.route('sales.searchItems'), {params})
        .then(response => {
          //this.form.item = null
          this.itemsData = response.data
          this.isLoading = false
        })
    },
    update() {
      if (this.form.item == null) return
      this.form.price = this.form.item.cost * this.form.quantity
      this.maxQty = this.form.item.quantity
    },
    updatePrice() {
      if (this.form.price != null && this.form.item.cost != null && this.form.quantity <= this.maxQty) {
        this.form.price = this.form.item.cost * this.form.quantity
      }
    }
  },
}
</script>
